import React from 'react';
import { Label } from '../../components/ui/label';

const PROVIDERS = [
  { value: 'gmail', label: 'Gmail (env fallback)' },
  { value: 'smtp', label: 'Custom SMTP' },
  { value: 'ses', label: 'AWS SES API' },
];

/**
 * Provider radio buttons — one row of three (Gmail / SMTP / SES) for a
 * given scope (system | customer). Disables SMTP / SES tiles when
 * their credentials aren't on file yet so the SuperAdmin doesn't end
 * up with a half-configured route.
 */
export function ProviderRadio({ scope, current, onChange, scopeLabel, disabled, smtpReady, sesReady }) {
  return (
    <div className="space-y-2" data-testid={`provider-radio-${scope}`}>
      <Label className="text-slate-300 text-xs uppercase tracking-wider">
        {scopeLabel}
      </Label>
      <div className="grid grid-cols-3 gap-2">
        {PROVIDERS.map((p) => {
          const blocked = (p.value === 'smtp' && !smtpReady) || (p.value === 'ses' && !sesReady);
          return (
            <button
              key={p.value}
              type="button"
              disabled={disabled || blocked}
              onClick={() => onChange(scope, p.value)}
              data-testid={`provider-${scope}-${p.value}`}
              className={`px-3 py-2 rounded-lg border text-xs font-medium transition ${
                current === p.value
                  ? 'bg-amber-500/20 border-amber-500/60 text-amber-200'
                  : 'bg-slate-800/50 border-slate-700 text-slate-300 hover:border-slate-600'
              } ${blocked ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}`}
            >
              {p.label}
              {blocked && <div className="text-[9px] text-amber-300 mt-0.5">Save creds first</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ProviderRadio;
